module.exports = __webpack_public_path__ + "91383412071e935954645c24eb3f3efe.MP3";